<div class="root">
  <app-navbar *ngIf="showNavbar"></app-navbar>
  <div class="main-body">
    <div class="sub-body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
